var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5063 2.45077C13.2969 2.42844 13.0842 2.41699 12.8689 2.41699C9.5866 2.41699 6.92578 5.07782 6.92578 8.36011C6.92578 11.6424 9.5866 14.3032 12.8689 14.3032C13.9285 14.3032 14.9234 14.0259 15.7849 13.5399C14.4079 15.3647 12.2212 16.5442 9.75903 16.5442C5.59249 16.5442 2.21484 13.1665 2.21484 9C2.21484 4.83346 5.59249 1.45581 9.75903 1.45581C11.1229 1.45581 12.4023 1.81773 13.5063 2.45077Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkIcon);
export default __webpack_public_path__ + "static/media/dark-icon.da441b6d099259ba855530f8e6d7ae5b.svg";
export { ForwardRef as ReactComponent };